import { render, staticRenderFns } from "./trashDetail.vue?vue&type=template&id=f97aaa88"
import script from "./trashDetail.vue?vue&type=script&lang=js"
export * from "./trashDetail.vue?vue&type=script&lang=js"
import style0 from "./trashDetail.vue?vue&type=style&index=0&id=f97aaa88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports